<template>
<div>
    <el-tabs v-model="activeName">
        <el-tab-pane label="收藏园区" name="first" class="">
            <div v-for="(item,index) in collectPark" :key="index" class="park-cont">
                <div class="parkname" @click="toDetail(item.yuanquId)">
                    {{item.name}}
                </div>
                <div class="parktype">
                    园区类型：{{item.parkType}}
                </div>
                <div class="parkaddress">
                    园区地址：{{item.address}}
                </div>
                <el-button type="danger" size="small" class="parkcollect" @click="toCancel(item.id)">取消收藏</el-button>
            </div>
        </el-tab-pane>
        <el-tab-pane label="专属大屏" name="second" class="clearfix p-2">
            <div v-if="!editShow">
                <div v-for="(item,index) in collectScreen" :key="index" class="screen-cont">
                    <div class="screenimg" :class="item.isUpdate==0?'canlook':''" @click="toParkPage(item.yuanquId,item.isUpdate)">
                        <img :src="defaultImg" alt="">
                        <div class="cantlayer" v-if="item.isUpdate==1">
                            <div class="text">正在生成中，请于次日9时查看</div>
                        </div>
                    </div>
                    <div class="flex-cont bottom-text">
                        <div class="screenname" :title="item.name">{{item.name}}</div>
                        <div class="screencollect">
                            <el-tooltip class="item" effect="dark" content="编辑" placement="bottom-start">
                                <el-link icon="el-icon-edit" :underline="false" class="edit" @click="openEdit(item)"></el-link>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="取消收藏" placement="bottom-start">
                                <el-link icon="el-icon-delete" :underline="false" class="collect" @click="toCancel(item.id)"></el-link>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="查看上传企业" placement="bottom-start">
                                <el-link icon="el-icon-tickets" :underline="false" class="lookupload" @click="openTable(item)"></el-link>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
            </div>
            <div class="revise-cont" v-loading="editLoading" v-else>
                <div class="edit-cont">
                    <el-form ref="editForm" :model="editForm" label-width="100px">
                        <el-form-item label="企业列表：">
                            <el-upload ref="company" accept=".xlsx" :auto-upload="false" action :on-preview="handlePreview" :before-upload="beforeCompanyUpload" :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed" :file-list="editForm.companyList">
                                <el-button size="small" type="primary">点击上传文件</el-button>
                                <el-link type="primary" @click="uploadTemplet">下载Excel模板</el-link>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="园区相册：">
                            <el-upload ref="img" accept=".jpg,.jpeg,.png" action :auto-upload="false" multiple list-type="picture-card" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :on-exceed="handleExceed1" :on-remove="handleRemove">
                                <i slot="default" class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                                <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="medium" @click="upload">确 定</el-button>
                            <el-button size="medium" @click="editShow=false">取 消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-tab-pane>
    </el-tabs>
    <el-dialog title="查看上传的企业" :visible.sync="tableShow" width="80%" :before-close="handleClose">
        <el-row style="margin-bottom:20px">
            <el-tag style="cursor:pointer" @click="qualificationSearch('')">不限({{allNum1}})</el-tag>
            <el-tag style="margin-left:20px;cursor:pointer" @click="qualificationSearch('国高企业')">国高企业({{numgg}})</el-tag>
            <el-tag style="margin-left:20px;cursor:pointer" @click="qualificationSearch('百强企业')">百强企业({{numbq}})</el-tag>
            <el-tag style="margin-left:20px;cursor:pointer" @click="qualificationSearch('瞪羚企业')">瞪羚企业({{numdl}})</el-tag>
            <el-tag style="margin-left:20px;cursor:pointer" @click="qualificationSearch('上市企业')">上市企业({{numss}})</el-tag>
            <el-tag style="margin-left:20px;cursor:pointer" @click="qualificationSearch('新三板企业')">新三板企业({{numxsb}})</el-tag>
            <el-tag style="margin-left:20px;cursor:pointer" @click="qualificationSearch('规上企业')">规上企业({{numgs}})</el-tag>
        </el-row>
        <el-row>
            <el-input style="width:600px" placeholder="请输入企业名称" v-model="CompanyName" clearable class="input-with-select">
                <el-select slot="prepend" v-model="typeName" placeholder="请选择" style="width:150px">
                    <el-option label="全部" :value="0"></el-option>
                    <el-option label="匹配成功" :value="1"></el-option>
                    <el-option :label="isMatch==1 ? '数据匹配中' :'未匹配到结果'" :value="2"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
            <template>
                <el-tag type="success" style="margin-left:20px;cursor:pointer" @click="toSearch(1)">匹配成功：{{num1}}条</el-tag>
                <el-tag type="danger" style="margin-left:10px;cursor:pointer" @click="toSearch(2)">{{isMatch==1 ? '数据匹配中：' :'未匹配到结果：'}}{{num2}}条</el-tag>
            </template>
            <el-button type="danger" @click="toDeleteCompany(0)" style="float:right">全部清空</el-button>
        </el-row>
        <el-table :data="companyList" border style="width: 100%;margin-top:20px" stripe>
            <el-table-column prop="name" label="企业名" align="center"></el-table-column>
            <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.uId">匹配成功</el-tag>
                    <el-tag type="danger" v-else>{{isMatch==1 ? '数据匹配中' :'未匹配到结果'}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" v-if="isMatch==0">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" v-if="scope.row.uId" @click="TemCom(scope.row.uId)">详情</el-button>
                    <el-button type="primary" size="small" @click="nameEdit(scope.row.id)">编辑</el-button>
                    <el-button type="danger" size="small" @click="toDeleteCompany(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="block" style="width:100%">
            <el-pagination :hide-on-single-page="true" style="margin:20px auto" background @current-change="handleCurrentChange" :page-size="PageSize" layout="total, prev, pager, next, jumper" :total="count"></el-pagination>
        </div>
    </el-dialog>

    <el-dialog title="修改企业名称" :visible.sync="nameEditShow" width="40%">
        <el-row>
            <el-input style="width:300px" placeholder="请输入企业名称" v-model="cName" clearable></el-input>
            <el-button type="primary" @click="toChangeCompany" style="float:right">确认</el-button>
        </el-row>
    </el-dialog>
</div>
</template>

<script>
import qs from "qs";
import {
    mapMutations
} from "vuex";
import {
    getCollectList,
    getRequestCode,
    toCalcelCollect,
    getCompanysList,
    deleteCompany,
    changeCompany,
    getMatchInfo,
} from "../../api/api.js";
export default {
    props: ['todo'],
    data() {
        return {
            name: "",
            typeName: 0,
            loading: false,
            editLoading: false,
            tableShow: false,
            collectPark: [],
            collectScreen: [],
            activeName: 'first',
            defaultImg: require("../../assets/images/example1.png"),
            headers: {
                Token: ''
            },
            editForm: {
                name: ''
            },
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
            fileList: [],
            editShow: false,
            selectItem: {},
            editForm: {
                imgList: ['http://localhost:21331/Upload/ImageUpload/2020_09_02/7ae45f2c3e4048e6ac519bd3b79f8b1e_20200902140906.png'],
                fileList: [],
                companyList: []
            },
            disabled: false,
            CompanyName: '',
            CurrentPage: 1,
            PageSize: 7,
            companyList: [],
            count: 0,
            page: 0,
            num1: 0,
            num2: 0,
            editId: 0,
            nameEditShow: false,
            cName: '',
            isFirst: true,
            isMatch: 1,
            numgg: 0,
            numbq: 0,
            numdl: 0,
            numss: 0,
            numxsb: 0,
            numgs: 0,
            qualification: '',
            allNum1: 0
        };
    },
    components: {},
    watch: {
        todo: {
            handler(newVal, oldVal) {
                if (newVal == 2) {
                    this.loadData();
                }
            }
        },
        deep: true
    },
    created() {
        if (this.todo == 2) {
            this.loadData();
        }
    },
    mounted() {},
    methods: {
        //获取数据
        loadData: function () {
            let _this = this;
            _this.loading = true;
            let result1 = _this.getList();
            Promise.all([result1]).then(res => {
                _this.loading = false;
            });
            _this.headers.Token = localStorage.getItem('parkToken');
        },
        getList() {
            let _this = this;
            // _this.loading = true;
            return new Promise((resolve, reject) => {
                let StrJson = {};
                let params = {
                    StrJson: JSON.stringify(StrJson)
                };
                getCollectList(params)
                    .then(function (response) {
                        let res = response.data;
                        let jsonData = [];
                        if (res.code == 1) {
                            _this.collectPark = res.data.collectPark;
                            _this.collectScreen = res.data.collectScreen;
                        }
                        resolve(resolve);
                    })
                    .catch(function (error) {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        getMatch() {
            let _this = this;
            // _this.loading = true;
            return new Promise((resolve, reject) => {
                let StrJson = {
                    ParkId: _this.selectItem.yuanquId
                };
                let params = {
                    StrJson: JSON.stringify(StrJson)
                };
                getMatchInfo(params)
                    .then(function (response) {
                        let res = response.data;
                        let jsonData = [];
                        if (res.code == 1) {
                            _this.isMatch = res.data
                        }
                        resolve(res);
                    })
                    .catch(function (error) {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        TemCom(uId) {
            if (!uId) {
                this.commonTipsError('无此企业详情');
                return;
            }
            uId = uId.replace("\"","").replace("\"","");
            window.open("/companyDetail?Code=" + uId);

        },
        toDetail(item) {
            window.open(this.$config.Yqk.pageUrl + '/parkdetail?id=' + item, '_blank');
        },
        toParkPage(yuanquId, isUpdate) {
            let _this = this;
            if (isUpdate == 0) {
                let StrJson = {
                    Id: yuanquId,
                    Name: _this.CompanyName,
                    CurrentPage: _this.CurrentPage,
                    PageSize: _this.PageSize
                };
                let params = {
                    StrJson: JSON.stringify(StrJson)
                };
                getCompanysList(params)
                    .then(function (response) {
                        let res = response.data;
                        let jsonData = [];
                        if (res.code == 1) {
                            if (res.sumCount > 0) {
                                _this.GetCode(_this.$config.Dp.systemCode, _this.$config.Dp.pageUrl + '/privatedpindex?id=' + yuanquId);
                            } else {
                                _this.GetCode(_this.$config.Dp.systemCode, _this.$config.Dp.pageUrl + '/bigScreen?id=' + yuanquId);
                            }
                        } else {
                            _this.GetCode(_this.$config.Dp.systemCode, _this.$config.Dp.pageUrl + '/bigScreen?id=' + yuanquId);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        _this.GetCode(_this.$config.Dp.systemCode, _this.$config.Dp.pageUrl + '/bigScreen?id=' + yuanquId);
                    });
            }

        },
        GetCode(SysId, url) {
            let params = {
                SystemId: SysId,
            };
            var parkToken = localStorage.getItem("parkToken");
            if (!parkToken) {
                //直接跳转http
                this.commonTipsError('请登录后再试');
            } else {
                getRequestCode(params)
                    .then(function (response) {
                        let res = response.data;
                        if (res.code == 1) {
                            //console.log('');
                            window.open(url + "&code=" + res.data);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
        toCancel(Id) {
            this.$confirm(" 是否确定取消该收藏？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    let _this = this;
                    _this.loading = true;
                    let StrJson = {
                        Id: Id,
                    };
                    let params = {
                        StrJson: JSON.stringify(StrJson)
                    };
                    toCalcelCollect(params)
                        .then(function (response) {
                            let res = response.data;
                            if (res.code == 1) {
                                _this.commonTipsSuccess("操作成功!");
                                _this.getList();
                                _this.loading = false;
                            } else {
                                _this.commonTipsError(res.result);
                                _this.loading = false;
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                })
                .catch(() => {
                    console.log("取消");
                });
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择1个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            this.editForm.companyList = [];
        },
        handleExceed1(files, fileList) {
            this.$message.warning(`当前限制选择9个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            this.editForm.imgList = [];
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        openEdit(item) {
            this.editShow = true;
            this.selectItem = item;
            let _this = this;
        },
        beforeCompanyUpload(file) {
            console.log(file);
            let isExcel = file.type == 'application/vnd.ms-excel' || file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            let isLt2M = file.size / 1024 / 1024 < 5;

            if (!isExcel) {
                this.$message.error('上传头像图片只能是Excel格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 5M!');
            }
            return isJPG && isLt2M;
        },
        beforeAvatarUpload(file) {
            let isJPG = file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png';
            let isLt2M = file.size / 1024 / 1024 < 0.5;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG或者Png 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 500KB!');
            }
            return isJPG && isLt2M;
        },
        upload() {
            let _this = this;
            let isJump = true;
            let companyList = _this.$refs.company.uploadFiles;
            if (companyList.length == 1) {
                console.log(companyList[0])
                //let isExcel = companyList[0].raw.type == 'application/vnd.ms-excel' || companyList[0].raw.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                let isExcel = companyList[0].raw.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                let isLt5M = (companyList[0].raw.size / 1024 / 1024) < 5;
                if (!isExcel) {
                    this.$message.error('企业名单的文件只能是 xlsx 格式!');
                }
                if (!isLt5M) {
                    this.$message.error('企业名单的文件大小不能超过 5M!');
                }
                if (!(isExcel && isLt5M)) {
                    return false;
                }
                isJump = false;
            }
            let imgList = _this.$refs.img.uploadFiles;
            let rawList = [];
            if (imgList.length > 0) {
                let num = 0;
                for (let i = 0; i < imgList.length; i++) {
                    let isJPG = imgList[i].raw.type == 'image/jpeg' || imgList[i].raw.type == 'image/jpg' || imgList[i].raw.type == 'image/png';
                    let isLt2M = (imgList[i].raw.size / 1024 / 1024) < 2;
                    let result = isJPG && isLt2M;
                    if (result) {
                        rawList.push(imgList[i].raw);
                    } else {
                        num++;
                    }
                }
                if (num > 0) {
                    this.$message.error(`有${num}张图片因为格式不对上传失败`);
                }
                if (num < 9) {
                    isJump = false;
                }
            }
            if (isJump === false) {
                let model = {
                    Id: _this.selectItem.id
                };
                const formData = new FormData();
                let url = '/Api/ToSubmitDp';
                formData.append("companyList", companyList.length > 0 ? companyList[0].raw : null);
                if (rawList.length > 0) {
                    for (let i = 0; i < rawList.length; i++) {
                        formData.append("imgList", rawList[i]);
                    }
                } else {
                    formData.append("imgList", null);
                }
                formData.append("StrJson", JSON.stringify(model));
                let token = localStorage.getItem('parkToken');
                formData.append("Token", token);
                _this.editLoading = true;
                _this.$http
                    .post(url, formData)
                    .then(function (response) {
                        let res = response.data;
                        console.log(res);
                        if (res.code == 1) {
                            _this.commonTipsSuccess(res.result);
                            _this.getList();
                            _this.editShow = false;
                        } else if (res.code == 0) {
                            _this.commonTipsError(res.result);
                        }
                        _this.editLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        _this.editLoading = false;
                    });
            } else {
                _this.editShow = false;
            }
        },
        openTable(item) {
            this.selectItem = item;
            this.isFirst = true;
            this.typeName = 0;
            this.CompanyName = '';
            this.CurrentPage = 1;
            let _this = this;
            _this.loading = true;
            let result1 = _this.getTableData();
            Promise.all([result1]).then(res => {
                _this.tableShow = true;
                _this.loading = false;
            });
        },
        qualificationSearch(item) {
            this.qualification = item;
            this.CompanyName = '';
            this.typeName = 0;
            this.search();
        },
        getTableData() {
            let _this = this;
            _this.getMatch();
            // _this.loading = true;
            return new Promise((resolve, reject) => {
                let StrJson = {
                    Id: _this.selectItem.yuanquId,
                    Name: _this.CompanyName,
                    Type: _this.typeName,
                    CurrentPage: _this.CurrentPage,
                    PageSize: _this.PageSize,
                    qualification: _this.qualification
                };
                let params = {
                    StrJson: JSON.stringify(StrJson)
                };
                getCompanysList(params)
                    .then(function (response) {
                        let res = response.data;
                        let jsonData = [];
                        if (res.code == 1) {
                            _this.companyList = res.data.list;
                            _this.count = res.sumCount;
                            _this.page = res.sumPage;
                            if (_this.CurrentPage == 1 && _this.isFirst) {
                                _this.num1 = res.data.num1;
                                _this.num2 = res.data.num2;
                                _this.isFirst = false;
                                _this.numgg = res.data.numgg;
                                _this.numbq = res.data.numbq;
                                _this.numdl = res.data.numdl;
                                _this.numss = res.data.numss;
                                _this.numxsb = res.data.numxsb;
                                _this.numgs = res.data.numgs;
                                _this.allNum1 = res.sumCount;
                            }
                        }
                        resolve(resolve);
                    })
                    .catch(function (error) {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        handleCurrentChange(val) {
            this.CurrentPage = val;
            this.getTableData();
        },
        search() {
            this.CurrentPage = 1;
            //this.isFirst = true;
            this.getTableData();
        },
        handleClose() {
            this.tableShow = false;
        },
        uploadTemplet() {
            var hostname = window.location.hostname;
            let url = "";
            if (hostname == 'localhost') {
                url = 'http://localhost:8090/企业列表上传模版.xlsx';
            } else {
                url = 'http://' + hostname + '/企业列表上传模版.xlsx';
            }
            let link = document.createElement('a');
            link.href = url;
            link.click();
        },
        toDeleteCompany(Id) {
            this.$confirm(Id == 0 ? "是否全部清空" : "是否删除该企业", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    let _this = this;
                    // _this.loading = true;
                    return new Promise((resolve, reject) => {
                        let StrJson = {
                            Id: Id,
                            ParkId: _this.selectItem.yuanquId
                        };
                        let params = {
                            StrJson: JSON.stringify(StrJson)
                        };
                        deleteCompany(params)
                            .then(function (response) {
                                let res = response.data;
                                let jsonData = [];
                                if (res.code == 1) {
                                    _this.commonTipsSuccess(res.result);
                                    _this.CurrentPage = 1;
                                    _this.isFirst = true;
                                    _this.getTableData();
                                }
                                resolve(resolve);
                            })
                            .catch(function (error) {
                                console.log(error);
                                reject(error);
                            });
                    });
                })
                .catch(() => {

                });

        },
        nameEdit(Id) {
            this.editId = Id;
            this.nameEditShow = true;
        },
        toSearch(type) {
            this.typeName = type;
            this.search();
        },
        toChangeCompany() {
            let _this = this;
            // _this.loading = true;
            return new Promise((resolve, reject) => {
                let StrJson = {
                    Id: _this.editId,
                    Name: _this.cName,
                    ParkId: _this.selectItem.yuanquId
                };
                let params = {
                    StrJson: JSON.stringify(StrJson)
                };
                changeCompany(params)
                    .then(function (response) {
                        let res = response.data;
                        let jsonData = [];
                        if (res.code == 1) {
                            _this.commonTipsSuccess(res.result);
                            _this.CurrentPage = 1;
                            _this.getTableData();
                            _this.nameEditShow = false;
                            _this.getList();
                        }
                        resolve(resolve);
                    })
                    .catch(function (error) {
                        console.log(error);
                        reject(error);
                    });
            });
        },
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/index/mycollect.vue